import {
  collection,
  query,
  where,
  getDocs,
  orderBy,
  limit as firestoreLimit,
  Timestamp,
  Query
} from 'firebase/firestore';
import { db } from '../config';
import { auth } from '../firebase';
import type { Generation } from '../../../../types/generation';
import { GenerationQueryOptions } from './types';

export async function getRecentGenerations(
  options: GenerationQueryOptions = {}
): Promise<Generation[]> {
  if (!auth.currentUser) {
    throw new Error('No authenticated user');
  }

  try {
    const generationsRef = collection(db, 'generations');
    const constraints = [
      where('userID', '==', auth.currentUser.uid),
      orderBy('timestamp', options.orderBy || 'desc')
    ];

    if (options.type) {
      constraints.push(where('type', '==', options.type));
    }

    if (options.limit) {
      constraints.push(firestoreLimit(options.limit));
    }

    const q = query(generationsRef, ...constraints);
    const querySnapshot = await getDocs(q);

    return querySnapshot.docs.map((doc) => {
      const data = doc.data();
      const timestamp = data.timestamp as Timestamp;

      return {
        id: doc.id,
        userID: data.userID,
        content: data.content,
        jobDescription: data.jobDescription,
        filters: data.filters,
        type: data.type || 'letter', // Default to 'letter' for backward compatibility
        timestamp:
          timestamp?.toDate?.().toISOString() || new Date().toISOString()
      } as Generation;
    });
  } catch (error) {
    console.error('Error fetching generations:', error);
    throw new Error('Failed to fetch generations');
  }
}